import VxeIconComponent from './src/icon';
import { dynamicApp } from '../dynamics';
export var VxeIcon = Object.assign(VxeIconComponent, {
    install: function (app) {
        app.component(VxeIconComponent.name, VxeIconComponent);
    }
});
export var Icon = VxeIcon;
dynamicApp.component(VxeIcon.name, VxeIcon);
export default VxeIcon;
